import { subCompaniesApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';

export const SUB_COMPANIES_ACTION_TYPE = {
  GET_SUB_COMPANIES: 'GET_SUB_COMPANIES',
  GET_SUB_COMPANY_BY_ID: 'GET_SUB_COMPANY_BY_ID',
  UPDATE_SUB_COMPANY: 'UPDATE_SUB_COMPANY',
  RESET_SUB_COMPANIES_STATE: 'RESET_SUB_COMPANIES_STATE',
};

export const getSubCompaniesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await subCompaniesApi.getSubCompanies();

  return dispatch({
    type: SUB_COMPANIES_ACTION_TYPE.GET_SUB_COMPANIES,
    payload: data,
  });
});

export const getSubCompanyByIdAction = catchAsyncActionError(id => async dispatch => {
  const { data } = await subCompaniesApi.getSubCompanyById(id);

  return dispatch({
    type: SUB_COMPANIES_ACTION_TYPE.GET_SUB_COMPANY_BY_ID,
    payload: data,
  });
});

export const updateSubCompanyAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await subCompaniesApi.updateSubCompany(params);

  return dispatch({
    type: SUB_COMPANIES_ACTION_TYPE.UPDATE_SUB_COMPANY,
    payload: data,
  });
});

export const resetSubCompaniesAction = () => ({
  type: SUB_COMPANIES_ACTION_TYPE.RESET_SUB_COMPANIES_STATE,
});
